import { render, staticRenderFns } from "./FinanceNotification.vue?vue&type=template&id=06d1b020&scoped=true"
import script from "./FinanceNotification.vue?vue&type=script&lang=js"
export * from "./FinanceNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1b020",
  null
  
)

export default component.exports